import * as THREE from "three";
export var rttUniforms = {
    xPosition: {
        type: "f",
        value: 0.0
    },
    yPosition: {
        type: "f",
        value: 0.0
    },
    zPosition: {
        type: "f",
        value: 0.0
    },
    spriteTilesWide: {
        type: "f",
        value: 1.0
    },
    spriteTilesTall: {
        type: "f",
        value: 1.0
    },
    spriteIndexX: {
        type: "f",
        value: 0.0
    },
    spriteIndexY: {
        type: "f",
        value: 0.0
    },
    spriteIndex: {
        type: "f",
        value: 0.0
    },
    time: {
        type: "f",
        value: 0.0
    },
    phase: {
        type: "i",
        value: 1
    },
    diffuse: {
        type: "c",
        value: new THREE.Color(0xaaeeff)
    },
    resolution: {
        type: "v2",
        value: new THREE.Vector2()
    },
    mouse: {
        type: "v2",
        value: new THREE.Vector2()
    },
    lightPosition: {
        type: "v3",
        value: new THREE.Vector3()
    },
    cameraPos: {
        type: "v3",
        value: new THREE.Vector3()
    },
    t0: {
        type: "t",
        value: null
    },
};
